import React from "react";
import { useSelector } from "react-redux";
import { shipping } from "../redux/selectors";

const ShippingOne = () => {
  const data = useSelector(shipping("landing"));
  return (
    <section className="shipping mb-24" id="shipping">
      <div className="container container-lg">
        <div className="row gy-4">
          {data &&
            data?.length > 0 &&
            data.map((val, index) => (
              <div key={index} className="col-xxl-3 col-sm-6">
                <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                  <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                    <img src={val.image.files.small.url} alt=""></img>
                  </span>
                  <div className="">
                    <h6 className="mb-0">{val.bold_text}</h6>
                    <span className="text-sm text-heading">{val.text}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default ShippingOne;
